export default class CustomGA {
    constructor(user, app_name = 'ReportApp') {
        this.user_id = user.username;
        this.app_version = user.app_version;
        window.gtag('config', 'GA_MEASUREMENT_ID', {
            app_name, 
            user_id: this.user_id 
        });
    }

    trackEvent(name, value = '') {
        try {
            const content = {
                value,
                user_id: this.user_id,
                app_version: this.app_version
            }
            window.gtag('event', name, content);
        } catch (e) {
            console.error(e);
        }
    }

    trackView(screen_name) {
        window.gtag('event', 'screen_view', { 
            screen_name,
            user_id: this.user_id,
            app_version: this.app_version 
        });
    }

    static init(user) {
        const instance = new CustomGA(user);
        window.GA = instance;
    }
}